// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".XNjdArDaLfJIww8RDNRqx{margin:2.5rem auto 3rem;max-width:360px;text-align:left}.yjE7fDtrmllp-oHNZ6jlb{margin:2.5rem auto 3rem;max-width:360px;text-align:left}._1_pC4rLNYolt8zrnhh9OUU{margin:0 auto 3rem;max-width:360px}", ""]);
// Exports
exports.locals = {
	"orderSummary": "XNjdArDaLfJIww8RDNRqx",
	"discountCode": "yjE7fDtrmllp-oHNZ6jlb",
	"btnSubmit": "_1_pC4rLNYolt8zrnhh9OUU"
};
module.exports = exports;
